const simpleNotificationPath = "/sounds/simple-notification.mp3"

const alarmAudio = new Audio(simpleNotificationPath)

export const playAlarm = (volume) => {
  alarmAudio.volume = volume
  alarmAudio.play()
}
